import { Text, IconButton, ButtonType, OverlayMode, IconSize, ChevronLeft, ChevronRight } from '@soteria/design-system-ve';

import * as styles from './ContentSearchPagination.css';

export interface ContentSearchPaginationProps {
  currentPage: number;
  hasMore: boolean;
  onPageChange: (page: number) => void;
  disabled?: boolean;
  totalPages?: number;
}

export function ContentSearchPagination({ currentPage, hasMore, onPageChange, disabled = false, totalPages }: ContentSearchPaginationProps) {
  const handlePrevious = () => {
    if (currentPage > 1 && !disabled) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (hasMore && !disabled) {
      onPageChange(currentPage + 1);
    }
  };

  const isPreviousDisabled = disabled || currentPage <= 1;
  const isNextDisabled = disabled || !hasMore;

  return (
    <div className={styles.paginationContainer}>
      <IconButton
        aria-label="Previous page"
        buttonType={ButtonType.Secondary}
        disabled={isPreviousDisabled}
        icon={ChevronLeft}
        iconSize={IconSize.XXSmall}
        overlayMode={OverlayMode.Solid}
        title="Previous page"
        onClick={handlePrevious}
      />

      <Text className={styles.pageIndicator}>{totalPages ? `Page ${currentPage} of ${totalPages}` : `Page ${currentPage}`}</Text>

      <IconButton
        aria-label="Next page"
        buttonType={ButtonType.Secondary}
        disabled={isNextDisabled}
        icon={ChevronRight}
        iconSize={IconSize.XXSmall}
        overlayMode={OverlayMode.Solid}
        title="Next page"
        onClick={handleNext}
      />
    </div>
  );
}
